import styled from "styled-components";
import { colors } from "./colors";

/** One of the three panels of the breakdown. */
export const Part = styled.div`
    padding: 20px;
`;

export const PartTitle = styled.h3`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: ${colors.ink};
`;

export const PartNote = styled.p`
    margin: 2px 0 0;
    font-size: 12px;
    color: ${colors.muted};
    strong { font-weight: 500; color: ${colors.ink}; }
`;
